import React from 'react'

export const TestComponent: React.FC<any> = () => {
    return <div>teste funcionou!</div>
}
